import '../styles/CertIcon.css';

import React, { MouseEvent } from 'react';

import { CSSProperties } from '@mui/material/styles/createTypography';
import CertIconImage from '../images/cert.svg';
import CertStatus from '../models/CertStatus';
import { ReactSVG } from 'react-svg';

interface CertIconProps {
  status: CertStatus;
  style?: CSSProperties;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const CertIcon = (props: CertIconProps) => {
  const clickable = props.status !== 'incomplete';

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (clickable && props.onClick) {
      props.onClick(event);
    }
  };

  return (
    <div onClick={handleClick}>
      <ReactSVG
        className={`cert-icon ${props.status}`}
        style={{ ...props.style, cursor: clickable ? 'pointer' : 'default' }}
        src={CertIconImage}
      />
    </div>
  );
};

export default CertIcon;
